import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'eventReport',
  initialState: { items: [] },
  reducers: {
    setItems(state, action) { state.items = action.payload; },
  }
});

export { actions as eventReportActions };
export { reducer as eventReportReducer };
